import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { H3 } from '../Typography'
import { ContentContainer } from '../Grid'

import { Colors, Gutter, MediaQueries } from '../../utils/styles'

const QuestionCard = styled.div`
  padding: ${Gutter.FULL};
  background: ${Colors.WHITE};
  border-radius: 8px;
  box-shadow: 0 36px 36px 0 rgba(6, 86, 217, 0.08);
  @media (max-width: ${MediaQueries.MOBILE}) {
    padding: ${Gutter.HALF};
  }
`

const QuestionHeaderContainer = styled.div`
  padding: ${Gutter.HALF};
  /* @media (max-width: ${MediaQueries.MOBILE}) {
    padding: ${Gutter.HALF};
  } */
`

const QuestionHeader = styled(H3)({
  color: Colors.BLACK,
  fontWeight: 500,
  fontSize: 24,
  marginBottom: Gutter.FULL,
})

const SectionDashboardQuestions = props => (
  <ContentContainer width={[1, 1, 2 / 3]} p={[4, Gutter.HALF, Gutter.HALF]}>
    <QuestionCard>
      {' '}
      <QuestionHeaderContainer>
        <h5 style={{ fontSize: 12, color: props.color, marginBottom: Gutter.QUARTER }}>
          {props.subtitle}
        </h5>
        <QuestionHeader>Key Business Questions Addressed</QuestionHeader>
      </QuestionHeaderContainer>
      <div>{props.questions}</div>
    </QuestionCard>
  </ContentContainer>
)

export default SectionDashboardQuestions

SectionDashboardQuestions.propTypes = {
  color: PropTypes.string,
  questions: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
}

SectionDashboardQuestions.defaultProps = {
  color: 'yellow',
  subtitle: 'Insert Dashboard Title Here',
}
